module.exports = __webpack_public_path__ + "img/00—01—Login—IB2 > Notification > Warning.4f2a0d42.jpg";